// Style Libraries
import "@popperjs/core";
import "bootstrap";
import "arrive";


// JS Libraries
import gsap from "gsap/dist/gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Sections
import Header from "./sections/_header";
import Tecniche from "./sections/_tecniche";
import preInterni from "./sections/_pre-interni";
import Interni from "./sections/_interni";
import comeLavoriamo from "./sections/_come-lavoriamo";
import Esterni from "./sections/_esterni";
import divaniPoltrone from "./sections/_divani-poltrone";
import Contatti from "./sections/_contatti";

// Common
import Scripts from "./_scripts";
